import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { clearAuthToken, decodeToken, getAuthToken } from "../utils/auth";
import { ROUTES } from "./routes";
import { PredefinedWord } from "./Predefined";
interface ProtectedRouteProps {
  allowedRoles?: string[];
}


const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const token = getAuthToken();
  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to={ROUTES.LOGIN}
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  const decoded = decodeToken(token);

  if (!decoded) {
    clearAuthToken();

    return (
      <Navigate
        to={ROUTES.LOGIN}
        replace
        state={{ from: location.pathname }}
      />
    );
  }
  const userRole = decoded?.role.trim().toLowerCase() || decoded?.roleName.trim().toLowerCase();

  // 🔒 Role restriction check
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  if (userRole === PredefinedWord.Roles.DENTIST) {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");

    const clinics = user?.clinicDetails ?? [];
    const hasApprovedClinic = clinics.some(
      (c: any) => c?.isApprove === true
    );
    if (!hasApprovedClinic) {
      if (location.pathname !== ROUTES.DENTIST.CLINIC_DETAILS) {
        return (
          <Navigate
            to={ROUTES.DENTIST.CLINIC_DETAILS}
            replace
          />
        );
      }
    }
  }


  return <Outlet />;
};

export default ProtectedRoute;
